
var initialDocumentTitle = document.title;

function notificationBell(data) {
    if(data.unread_count > 0) {
        var newTitle = '(' + data.unread_count + ') ' + initialDocumentTitle;
        document.title = newTitle;
        $(".notification-bell").removeClass("icon-bell-o").addClass("icon-bell is-active animated animated--briefly swing");
        $("#notificationsMenu .notification").remove(); //reset contents
        httpGet(mantl.prefix_path('/get_my_new_notifications')).then(
            function(value) {
                $("#notificationsMenu").append(value); //append because mark as read is first list item
            })
        .catch(
            function(reason) {
                console.error('Error loading new notifications into masthead.', reason);
            });
    } else {
        resetNotificationBell();
    }
}

function resetNotificationBell() {
    document.title = initialDocumentTitle;
    $(".notification-bell").addClass("icon-bell-o").removeClass("icon-bell is-active animated animated--briefly swing");
    $(".live_notify_badge").text("0");
}


function markNotificationsAsRead() {
    var r = new XMLHttpRequest();
    r.open("GET", mantl.prefix_path('/inbox/notifications/mark-all-as-read/'));
    r.send();
    resetNotificationBell()
}

function markNotificationAsRead(slug) {
    var r = new XMLHttpRequest();
    r.open("GET", mantl.prefix_path('/inbox/notifications/mark-as-read/') + slug);
    r.send();
    $('body').find('.notification[data-slug=' + slug + ']').removeClass('is-unread');
}

//test notifications
function make_notification() {
    var r = new XMLHttpRequest();
    r.open("GET", '/test_notify/', true);
    r.send();
}

//bind clickables
$(document).ready(function(){
    $("body").on('click',".notification-clickable",function(event){
        event.preventDefault();
        var slug = $(this).data('slug');
        var view_url = $(this).attr('href');
        httpGet(mantl.prefix_path('/inbox/notifications/mark-as-read/') + slug).then(
            function(value) {
                $('body').find('.notification[data-slug=' + slug + ']').removeClass('is-unread');
                window.location = view_url;
            })
        .catch(
            function(reason) {
                console.error('Unable to mark notification as read.', reason);
            });
    });
});
